export default __webpack_public_path__ + "static/media/library2.b8155309.jpg";